var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProtectionLargeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 52,
    viewBox: "0 0 50 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.4272 23.5458V11.4825L22.8421 5.70751L39.257 11.4825V20.9535C41.1994 21.2102 43.0324 21.7492 44.7286 22.4935V7.91484L22.8421 0.214844L0.955566 7.91484V23.5458C0.955566 36.5075 10.2847 48.5965 22.8421 51.5482C22.9242 51.5225 22.9789 51.4968 23.061 51.4968C20.8997 49.4948 19.2308 46.9795 18.2733 44.2075C11.2422 40.0752 6.4272 32.0928 6.4272 23.5458Z",
    fill: "#2D96B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9056 25.2398C28.5058 25.2398 22.5001 30.9637 22.5001 38.0162C22.5001 45.0688 28.5058 50.7926 35.9056 50.7926C43.3055 50.7926 49.3111 45.0688 49.3111 38.0162C49.3111 30.9637 43.3055 25.2398 35.9056 25.2398ZM40.3294 44.0211L34.5651 38.5273V30.3504H37.2462V37.4796L42.2062 42.2069L40.3294 44.0211Z",
    fill: "#EEA320"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtectionLargeIcon);
export default __webpack_public_path__ + "static/media/ProtectionLargeIcon.d5068824.svg";
export { ForwardRef as ReactComponent };